var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPriceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.570312,
    y: 0.5,
    width: 48,
    height: 48,
    rx: 4,
    fill: "#EA6B45"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17_170",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 25,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5703,
    y: 12.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17_170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5703 29.5H25.5703V28.5H26.5703C26.8536 28.5 27.0913 28.404 27.2833 28.212C27.4746 28.0207 27.5703 27.7833 27.5703 27.5V24.5C27.5703 24.2167 27.4746 23.979 27.2833 23.787C27.0913 23.5957 26.8536 23.5 26.5703 23.5H23.5703V22.5H27.5703V20.5H25.5703V19.5H23.5703V20.5H22.5703C22.287 20.5 22.0496 20.5957 21.8583 20.787C21.6663 20.979 21.5703 21.2167 21.5703 21.5V24.5C21.5703 24.7833 21.6663 25.0207 21.8583 25.212C22.0496 25.404 22.287 25.5 22.5703 25.5H25.5703V26.5H21.5703V28.5H23.5703V29.5ZM16.5703 32.5C16.0203 32.5 15.5496 32.3043 15.1583 31.913C14.7663 31.521 14.5703 31.05 14.5703 30.5V18.5C14.5703 17.95 14.7663 17.4793 15.1583 17.088C15.5496 16.696 16.0203 16.5 16.5703 16.5H32.5703C33.1203 16.5 33.5913 16.696 33.9833 17.088C34.3746 17.4793 34.5703 17.95 34.5703 18.5V30.5C34.5703 31.05 34.3746 31.521 33.9833 31.913C33.5913 32.3043 33.1203 32.5 32.5703 32.5H16.5703Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceIcon);
export default __webpack_public_path__ + "static/media/price-icon.7f9f2a8812f00f991e29274ba1753dca.svg";
export { ForwardRef as ReactComponent };